/**
 * Quote Builder Configuration
 * Actuele prijzen 2025-2026 voor website ontwikkeling
 * Gebaseerd op Netblitz pakketten
 */

export const quoteConfig = {
  // Stap 1: Type website (gebaseerd op nieuwe pakketten)
  websiteTypes: [
    { 
      id: 'starter', 
      name: { nl: 'Starter Website', en: 'Starter Website', fr: 'Starter Website', de: 'Starter Website' },
      description: { nl: 'Professionele one-page website', en: 'Professional one-page website', fr: 'Site one-page professionnel', de: 'Professionelle One-Page-Website' },
      basePrice: 599,
      icon: 'FileText'
    },
    { 
      id: 'business', 
      name: { nl: 'Business Website', en: 'Business Website', fr: 'Business Website', de: 'Business Website' },
      description: { nl: 'Complete website, 4-8 pagina\'s', en: 'Complete website, 4-8 pages', fr: 'Site complet, 4-8 pages', de: 'Komplette Website, 4-8 Seiten' },
      basePrice: 1099,
      icon: 'Building2'
    },
    { 
      id: 'portal', 
      name: { nl: 'Business Portal', en: 'Business Portal', fr: 'Business Portal', de: 'Business Portal' },
      description: { nl: 'Website + beveiligde klantomgeving', en: 'Website + secure client area', fr: 'Site + espace client sécurisé', de: 'Website + sicherer Kundenbereich' },
      basePrice: 1995,
      icon: 'Users'
    },
    { 
      id: 'pro', 
      name: { nl: 'Business Pro', en: 'Business Pro', fr: 'Business Pro', de: 'Business Pro' },
      description: { nl: 'Website + planning & administratie', en: 'Website + planning & administration', fr: 'Site + planning & administration', de: 'Website + Planung & Verwaltung' },
      basePrice: 2995,
      icon: 'Calendar'
    }
  ],

  // Stap 2: Extra pagina's
  extraPages: [
    { id: 'none', name: { nl: 'Geen extra pagina\'s', en: 'No extra pages', fr: 'Pas de pages supplémentaires', de: 'Keine zusätzlichen Seiten' }, price: 0 },
    { id: '3pages', name: { nl: '+3 pagina\'s', en: '+3 pages', fr: '+3 pages', de: '+3 Seiten' }, price: 150 },
    { id: '5pages', name: { nl: '+5 pagina\'s', en: '+5 pages', fr: '+5 pages', de: '+5 Seiten' }, price: 250 },
    { id: '10pages', name: { nl: '+10 pagina\'s', en: '+10 pages', fr: '+10 pages', de: '+10 Seiten' }, price: 450 }
  ],

  // Stap 3: Design opties
  designOptions: [
    { id: 'template', name: { nl: 'Template Design', en: 'Template Design', fr: 'Design template', de: 'Template Design' }, description: { nl: 'Professionele templates aangepast aan jouw stijl', en: 'Professional templates customized to your style', fr: 'Templates professionnels adaptés à votre style', de: 'Professionelle Templates angepasst an Ihren Stil' }, price: 0 },
    { id: 'custom', name: { nl: 'Custom Design', en: 'Custom Design', fr: 'Design personnalisé', de: 'Custom Design' }, description: { nl: 'Uniek ontwerp speciaal voor jou', en: 'Unique design specially for you', fr: 'Design unique spécialement pour vous', de: 'Einzigartiges Design speziell für Sie' }, price: 350 },
    { id: 'premium', name: { nl: 'Premium Design + Branding', en: 'Premium Design + Branding', fr: 'Design Premium + Branding', de: 'Premium Design + Branding' }, description: { nl: 'Inclusief logo en huisstijl', en: 'Including logo and corporate identity', fr: 'Logo et identité visuelle inclus', de: 'Inklusive Logo und Corporate Identity' }, price: 750 }
  ],

  // Stap 4: Functionaliteiten (meerdere selecteerbaar)
  features: [
    { id: 'contact', name: { nl: 'Contactformulier', en: 'Contact form', fr: 'Formulaire de contact', de: 'Kontaktformular' }, price: 0, included: true },
    { id: 'responsive', name: { nl: 'Responsive (mobiel-vriendelijk)', en: 'Responsive (mobile-friendly)', fr: 'Responsive (mobile)', de: 'Responsive (mobilfreundlich)' }, price: 0, included: true },
    { id: 'ssl', name: { nl: 'SSL Certificaat (HTTPS)', en: 'SSL Certificate (HTTPS)', fr: 'Certificat SSL (HTTPS)', de: 'SSL Zertifikat (HTTPS)' }, price: 0, included: true },
    { id: 'seo', name: { nl: 'Uitgebreide SEO per pagina', en: 'Extended SEO per page', fr: 'SEO étendu par page', de: 'Erweiterte SEO pro Seite' }, price: 149 },
    { id: 'google_business', name: { nl: 'Google Bedrijfsprofiel koppeling', en: 'Google Business Profile link', fr: 'Lien profil Google Business', de: 'Google Business Profil Verknüpfung' }, price: 99 },
    { id: 'social', name: { nl: 'Social Media Integratie', en: 'Social Media Integration', fr: 'Intégration réseaux sociaux', de: 'Social Media Integration' }, price: 99 },
    { id: 'multilingual_2', name: { nl: 'Meertalig (2 talen: NL/FR)', en: 'Multilingual (2 languages)', fr: 'Multilingue (2 langues)', de: 'Mehrsprachig (2 Sprachen)' }, price: 249 },
    { id: 'multilingual_3', name: { nl: 'Meertalig (3 talen: NL/FR/EN)', en: 'Multilingual (3 languages)', fr: 'Multilingue (3 langues)', de: 'Mehrsprachig (3 Sprachen)' }, price: 399 },
    { id: 'blog', name: { nl: 'Blog / Nieuws sectie', en: 'Blog / News section', fr: 'Section Blog / Actualités', de: 'Blog / News Bereich' }, price: 199 },
    { id: 'gallery', name: { nl: 'Referenties / Portfolio sectie', en: 'References / Portfolio section', fr: 'Section Références / Portfolio', de: 'Referenzen / Portfolio Bereich' }, price: 149 },
    { id: 'analytics', name: { nl: 'Google Analytics Integratie', en: 'Google Analytics Integration', fr: 'Intégration Google Analytics', de: 'Google Analytics Integration' }, price: 79 },
    { id: 'whatsapp', name: { nl: 'WhatsApp / Click-to-call knop', en: 'WhatsApp / Click-to-call button', fr: 'Bouton WhatsApp / Click-to-call', de: 'WhatsApp / Click-to-call Button' }, price: 49 }
  ],

  // Stap 5: Hosting & Onderhoud (aangepast aan pakketten)
  hosting: [
    { id: 'none', name: { nl: 'Geen hosting (zelf regelen)', en: 'No hosting (self-managed)', fr: 'Pas d\'hébergement', de: 'Kein Hosting (selbst verwaltet)' }, priceMonthly: 0, priceYearly: 0 },
    { id: 'starter', name: { nl: 'Starter Hosting', en: 'Starter Hosting', fr: 'Hébergement Starter', de: 'Starter Hosting' }, description: { nl: 'Hosting + domein + basis support', en: 'Hosting + domain + basic support', fr: 'Hébergement + domaine + support de base', de: 'Hosting + Domain + Basis Support' }, priceMonthly: 29, priceYearly: 299 },
    { id: 'business', name: { nl: 'Business Hosting', en: 'Business Hosting', fr: 'Hébergement Business', de: 'Business Hosting' }, description: { nl: 'Hosting + domein + updates + support', en: 'Hosting + domain + updates + support', fr: 'Hébergement + domaine + mises à jour + support', de: 'Hosting + Domain + Updates + Support' }, priceMonthly: 39, priceYearly: 399 },
    { id: 'clientzone', name: { nl: 'Klantzone Hosting', en: 'Client Portal Hosting', fr: 'Hébergement Portail', de: 'Kundenportal Hosting' }, description: { nl: 'Website + portaal hosting + support', en: 'Website + portal hosting + support', fr: 'Site + hébergement portail + support', de: 'Website + Portal Hosting + Support' }, priceMonthly: 49, priceYearly: 499 },
    { id: 'planning', name: { nl: 'Planning & App Hosting', en: 'Planning & App Hosting', fr: 'Hébergement Planning & App', de: 'Planung & App Hosting' }, description: { nl: 'Website + app + bugfixes + support', en: 'Website + app + bug fixes + support', fr: 'Site + app + corrections + support', de: 'Website + App + Bugfixes + Support' }, priceMonthly: 79, priceYearly: 799 }
  ],

  // Stap 6: Tijdlijn
  timeline: [
    { id: 'relaxed', name: { nl: 'Flexibel (4-6 weken)', en: 'Flexible (4-6 weeks)', fr: 'Flexible (4-6 semaines)', de: 'Flexibel (4-6 Wochen)' }, multiplier: 1 },
    { id: 'normal', name: { nl: 'Standaard (2-4 weken)', en: 'Standard (2-4 weeks)', fr: 'Standard (2-4 semaines)', de: 'Standard (2-4 Wochen)' }, multiplier: 1 },
    { id: 'fast', name: { nl: 'Snel (7-10 werkdagen)', en: 'Fast (7-10 business days)', fr: 'Rapide (7-10 jours ouvrables)', de: 'Schnell (7-10 Werktage)' }, multiplier: 1.15, surchargeLabel: { nl: '+15% spoedtoeslag', en: '+15% rush fee', fr: '+15% frais urgence', de: '+15% Eilzuschlag' } },
    { id: 'urgent', name: { nl: 'Urgent (< 1 week)', en: 'Urgent (< 1 week)', fr: 'Urgent (< 1 semaine)', de: 'Dringend (< 1 Woche)' }, multiplier: 1.35, surchargeLabel: { nl: '+35% spoedtoeslag', en: '+35% rush fee', fr: '+35% frais urgence', de: '+35% Eilzuschlag' } }
  ]
};

// Helper function to get translated text
export const getQuoteText = (obj, language) => {
  if (typeof obj === 'string') return obj;
  return obj[language] || obj.nl || obj;
};

// Calculate total price
export const calculateQuotePrice = (selections) => {
  let total = 0;
  
  // Base price from website type
  const websiteType = quoteConfig.websiteTypes.find(t => t.id === selections.websiteType);
  if (websiteType) total += websiteType.basePrice;
  
  // Extra pages
  const extraPages = quoteConfig.extraPages.find(p => p.id === selections.extraPages);
  if (extraPages) total += extraPages.price;
  
  // Design option
  const design = quoteConfig.designOptions.find(d => d.id === selections.design);
  if (design) total += design.price;
  
  // Features
  if (selections.features && selections.features.length > 0) {
    selections.features.forEach(featureId => {
      const feature = quoteConfig.features.find(f => f.id === featureId);
      if (feature && !feature.included) total += feature.price;
    });
  }
  
  // Timeline multiplier
  const timeline = quoteConfig.timeline.find(t => t.id === selections.timeline);
  if (timeline && timeline.multiplier > 1) {
    total = Math.round(total * timeline.multiplier);
  }
  
  // Hosting (first year or monthly)
  const hosting = quoteConfig.hosting.find(h => h.id === selections.hosting);
  const hostingCost = hosting ? (selections.hostingPeriod === 'yearly' ? hosting.priceYearly : hosting.priceMonthly * 12) : 0;
  
  return {
    oneTime: total,
    hostingYearly: hostingCost,
    total: total + hostingCost
  };
};

export default quoteConfig;
